import React from 'react';
import ReactTooltip from 'react-tooltip';
import { ErrorBoundary } from './ErrorBoundary';

import './PageLayout.scss';
export interface PageLayoutProps {
	header: JSX.Element,
	content: JSX.Element,
	footer?: JSX.Element,
}

function PageLayout(props: PageLayoutProps): JSX.Element {
	const { header } = props;

	return (
		<ErrorBoundary>
		<div className="page">
			<header className="page__header">
				{header}
			</header>
			<main className="page__content">
				{props.content}
				<ReactTooltip multiline={true} />
			</main>
			<footer className="page__footer">
				{props.footer}
			</footer>
		</div>
		</ErrorBoundary>
	);
}

export {PageLayout};
